import { Button } from '@material-ui/core'
import { confirmSignUp, resendSignUpCode, signIn } from 'aws-amplify/auth'
import * as React from 'react'
import { Redirect, useHistory, useLocation } from 'react-router-dom'

import { SectionSubTitle } from '../../components/atoms/SectionTittle'
import { TextInputEx } from '../../components/atoms/TextInputEx'
import { containerStyles } from '../../styles/ContainerStyles'
import { invoke } from '../../utils/helper'

export const ConfirmSignUp: React.FC = () => {

    const [code, setCode] = React.useState<string>('')

    const history = useHistory()
    const { state }: { state: {
        email: string, password: string, firstName: string, lastName: string
    } } = useLocation()

    if (!state?.email) {
        return <Redirect to="/" />
    }

    const styles = containerStyles()

    const confirmSignUpCode = async () => {
        await invoke(async () => {
            await confirmSignUp({ username: state.email, confirmationCode: code })
            // Auto sign-in after successful email confirmation
            await signIn({ username: state.email, password: state.password })
        }, {
            operation: 'Bekræfter konto',
            showSuccess: true
        })

        history.push({ pathname: '/afslutte', state })
    }

    const resendCode = async () => {
        await invoke(async () => {
            await resendSignUpCode({ username: state.email })
        }, {
            operation: 'Gensende kode',
            showSuccess: true
        })
    }

    return (
        <div className={styles.authContainer}>
            <div className={styles.innerAuthContainer}>
                <div>
                    <SectionSubTitle text="Bekræft Konto"/>
                </div>
                <div>
                    <small style={{ color: 'white' }}> Vi har sendt en bekræftelseskode til din mail</small>
                    <TextInputEx fullWidth value={code} onChange={setCode} label="Kode" />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>

                    <Button
                        disabled={code.length !== 6}
                        onClick={confirmSignUpCode}
                        className="btn-auth">
                        Bekræft kode
                    </Button>
                    <span
                        style={{
                            color: '#33949E', cursor: 'pointer', marginTop: 10, marginBottom: 20
                        }}
                        onClick={resendCode}>
                        Hvis du ikke har en kode, så klik her.
                    </span>

                </div>
            </div>

        </div>
    )

}
